import qs from 'query-string';
import Configuration from './Configuration.json';

const SESSION_ADDRESS_ID_KEY = 'Skinny-sign-up-address-id';

const getAddressIdFromSession = () => {
  if (window.sessionStorage) {
    return window.sessionStorage.getItem(SESSION_ADDRESS_ID_KEY);
  }
  return null;
};

const setAddressIdToSession = (addressId) => {
  if (window.sessionStorage) {
    window.sessionStorage.setItem(SESSION_ADDRESS_ID_KEY, addressId);
  }
};

const clearAddressIdFromSession = () => {
  if (window.sessionStorage) {
    window.sessionStorage.removeItem(SESSION_ADDRESS_ID_KEY);
  }
};

const getAddressIdFromQueryString = (props) => {
  const { location } = props;
  const queryParams = qs.parse(location.search || '');
  return queryParams.addressId;
};

const changeAddress = resetAddressSearch => () => {
  resetAddressSearch();
  clearAddressIdFromSession();
  window.location = Configuration.homeUrl;
};

export default {
  getAddressIdFromSession,
  setAddressIdToSession,
  clearAddressIdFromSession,
  getAddressIdFromQueryString,
  changeAddress
};



/** WEBPACK FOOTER **
 ** ./src/common/AddressIdUtil.js
 **/